import { c as _c } from "react/compiler-runtime";
import type { AutoshipCustomerApiResponse } from '@libs/common-types';
import { useAutoshipSubscriptionsQuery } from '../queries';
export type UseCustomerAutoshipSubscriptionsResult = {
  autoshipData: AutoshipCustomerApiResponse | undefined;
  isReady: boolean;
  isLoading: boolean;
  isFetching: boolean;
  isError: boolean;
};
const ONE_MINUTE = 60 * 1000;
export const useCustomerAutoshipSubscriptions = () => {
  const $ = _c(7);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      staleTime: ONE_MINUTE
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    data: autoshipData,
    isLoading,
    isFetching,
    isError
  } = useAutoshipSubscriptionsQuery(t0);
  const isReady = !isLoading && !isError;
  let t1;
  if ($[1] !== autoshipData || $[2] !== isError || $[3] !== isFetching || $[4] !== isLoading || $[5] !== isReady) {
    t1 = {
      autoshipData,
      isReady,
      isLoading,
      isFetching,
      isError
    };
    $[1] = autoshipData;
    $[2] = isError;
    $[3] = isFetching;
    $[4] = isLoading;
    $[5] = isReady;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};